import { MemberGroups } from "shared-types";
import { getUserGroup } from "../services/authorization/helpers/user";

export function checkIsAgent() {
  return getUserGroup() === MemberGroups.agent;
}
